import { render } from "./Index.vue?vue&type=template&id=58ae3825&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=58ae3825&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/v.vutet.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ae3825"]])

export default __exports__